import styled, { css } from 'styled-components';
import {
  spacing, containers
} from '@comicrelief/component-library';

const Wrapper = styled.div`
  background: ${({ theme, cardsBackground }) => theme.color(cardsBackground)};
  padding-top: ${({ paddingTop }) => paddingTop};
  padding-bottom: ${({ paddingBottom }) => paddingBottom};
  padding-inline: 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding-inline: 2rem;
  }

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    padding-inline: 4rem;
  }
`;

const Copy = styled.span`
  ${({ centred }) => (centred ? 'text-align: center' : null)}
`;

const Grid = styled.div`
  display: flex;
  width: 100%;
  max-width: ${containers.medium};
  margin: 0 auto;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    flex-direction: row;
    gap: 2rem;
  }
`;

const Items = styled.div`
  margin: 0 0 ${spacing('md')};
  width: 100%;
  text-align: left;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(100% / 2 - ${spacing('l')});

  &:last-of-type {
    margin-bottom: 0;
  }

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    margin: 0;
  }

  @media ${({ theme }) => theme.allBreakpoints('XL')} {
    flex-basis: ${({ layout }) => {
    switch (layout) {
      case '3 columns':
        return `calc(100% / 3 - ${spacing('l')}); flex-grow: 0`;
      case '4 columns':
        return `calc(100% / 4 - ${spacing('l')}); flex-grow: 0`;
      default:
        return null;
    }
  }}
  }
`;

const Line = styled.hr`
  border: none;
  height: 1px;
  background-color: ${({ theme }) => theme.color('grey_medium')};
  display: none;
  margin: ${spacing('m')} ${spacing('sm')} ${spacing('sm')};
  ${({ smallBreakpointRowLayout }) => (smallBreakpointRowLayout
    === true) && css`
    @media ${({ theme }) => theme.allBreakpoints('S')} {
      display: block;
    }
  `}
  ${({ mediumBreakpointRowLayout }) => (mediumBreakpointRowLayout
    === true) && css`
    @media ${({ theme }) => theme.allBreakpoints('M')} {
      display: block;
    }
  `}
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    display: none;
  }
`;

export {
  Wrapper,
  Copy,
  Grid,
  Items,
  Line
};
